<app-ssc-shell title="Language Assets">
  <section class="language-assets-page">
    <div class="ssc-grid g4">
      <div class="ssc-card"><div class="ssc-muted">Glossary Terms</div><div class="ssc-kpi">{{ summary.glossary_terms }}</div></div>
      <div class="ssc-card"><div class="ssc-muted">TM Segments</div><div class="ssc-kpi">{{ summary.tm_segments }}</div></div>
      <div class="ssc-card"><div class="ssc-muted">Corpus Pairs</div><div class="ssc-kpi">{{ summary.corpus_pairs }}</div></div>
      <div class="ssc-card"><div class="ssc-muted">Benchmark Items</div><div class="ssc-kpi">{{ summary.benchmark_items }}</div></div>
    </div>

    <section class="ssc-card asset-workbench">
      <div class="asset-head">
        <div class="asset-tabs">
          <button type="button" [class.active]="activeTab === 'glossary'" (click)="switchTab('glossary')">Glossary</button>
          <button type="button" [class.active]="activeTab === 'tm'" (click)="switchTab('tm')">Translation Memory</button>
          <button type="button" [class.active]="activeTab === 'corpus'" (click)="switchTab('corpus')">Corpus</button>
          <button type="button" [class.active]="activeTab === 'benchmark'" (click)="switchTab('benchmark')">Benchmark</button>
        </div>
        <div class="asset-search">
          <input [(ngModel)]="searchText" placeholder="Search assets">
          <button class="ssc-btn" type="button" (click)="search()">Search</button>
        </div>
      </div>

      @if (errorMessage) {
        <div class="asset-error">{{ errorMessage }}</div>
      }

      @if (activeTab === 'glossary') {
        <div class="asset-layout">
          <form class="asset-form" (ngSubmit)="saveGlossary()">
            <h3 class="ssc-section-title">Glossary Management</h3>
            <input [(ngModel)]="glossaryForm.source_term" name="source_term" placeholder="Source term">
            <input [(ngModel)]="glossaryForm.target_term" name="target_term" placeholder="Target term">
            <input [(ngModel)]="glossaryForm.source_language" name="source_language" placeholder="Source language">
            <input [(ngModel)]="glossaryForm.target_language" name="target_language" placeholder="Target language">
            <input [(ngModel)]="glossaryForm.subject" name="subject" placeholder="Subject">
            <textarea [(ngModel)]="glossaryForm.definition" name="definition" placeholder="Definition"></textarea>
            <textarea [(ngModel)]="glossaryForm.context_note" name="context_note" placeholder="Context note"></textarea>
            <select [(ngModel)]="glossaryForm.status" name="status">
              <option>Draft</option>
              <option>Approved</option>
              <option>Rejected</option>
            </select>
            <button class="ssc-btn primary" type="submit" [disabled]="saving">Save Term</button>
          </form>
          <div class="asset-table-wrap">
            <table class="ssc-table">
              <thead><tr><th>Source</th><th>Target</th><th>Pair</th><th>Subject</th><th>Status</th></tr></thead>
              <tbody>
                @for (row of glossaryRows; track row['id']) {
                  <tr>
                    <td>{{ text(row['source_term']) }}</td>
                    <td>{{ text(row['target_term']) }}</td>
                    <td>{{ text(row['source_language']) }} -> {{ text(row['target_language']) }}</td>
                    <td>{{ text(row['subject']) }}</td>
                    <td>{{ text(row['status']) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      @if (activeTab === 'tm') {
        <div class="asset-layout">
          <form class="asset-form" (ngSubmit)="saveTm()">
            <h3 class="ssc-section-title">Translation Memory</h3>
            <textarea [(ngModel)]="tmForm.source_text" name="tm_source_text" placeholder="Approved source text"></textarea>
            <textarea [(ngModel)]="tmForm.target_text" name="tm_target_text" placeholder="Approved target text"></textarea>
            <input [(ngModel)]="tmForm.source_language" name="tm_source_language" placeholder="Source language">
            <input [(ngModel)]="tmForm.target_language" name="tm_target_language" placeholder="Target language">
            <input [(ngModel)]="tmForm.subject" name="tm_subject" placeholder="Subject">
            <button class="ssc-btn primary" type="submit" [disabled]="saving">Add TM Segment</button>
          </form>
          <div class="asset-table-wrap">
            <table class="ssc-table">
              <thead><tr><th>Source</th><th>Target</th><th>Pair</th><th>Subject</th><th>Status</th><th>Source</th></tr></thead>
              <tbody>
                @for (row of tmRows; track row['source'] + '-' + row['id']) {
                  <tr>
                    <td>{{ text(row['source_text']) }}</td>
                    <td>{{ text(row['target_text']) }}</td>
                    <td>{{ text(row['source_language']) }} -> {{ text(row['target_language']) }}</td>
                    <td>{{ text(row['subject']) }}</td>
                    <td>{{ text(row['status']) }}</td>
                    <td>{{ text(row['source']) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      @if (activeTab === 'corpus') {
        <div class="asset-layout">
          <form class="asset-form" (ngSubmit)="saveCorpus()">
            <h3 class="ssc-section-title">Corpus Repository</h3>
            <textarea [(ngModel)]="corpusForm.source_text" name="corpus_source_text" placeholder="Source text"></textarea>
            <textarea [(ngModel)]="corpusForm.target_text" name="corpus_target_text" placeholder="Target text"></textarea>
            <input [(ngModel)]="corpusForm.source_language" name="corpus_source_language" placeholder="Source language">
            <input [(ngModel)]="corpusForm.target_language" name="corpus_target_language" placeholder="Target language">
            <input [(ngModel)]="corpusForm.subject" name="corpus_subject" placeholder="Subject">
            <input [(ngModel)]="corpusForm.source_file" name="corpus_source_file" placeholder="Source file">
            <button class="ssc-btn primary" type="submit" [disabled]="saving">Add Corpus Entry</button>
          </form>
          <div class="asset-table-wrap">
            <table class="ssc-table">
              <thead><tr><th>Source</th><th>Target</th><th>Pair</th><th>Subject</th><th>File</th><th>Source</th></tr></thead>
              <tbody>
                @for (row of corpusRows; track row['source'] + '-' + row['id']) {
                  <tr>
                    <td>{{ text(row['source_text']) }}</td>
                    <td>{{ text(row['target_text']) }}</td>
                    <td>{{ text(row['source_language']) }} -> {{ text(row['target_language']) }}</td>
                    <td>{{ text(row['subject']) }}</td>
                    <td>{{ text(row['source_file']) }}</td>
                    <td>{{ text(row['source']) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      @if (activeTab === 'benchmark') {
        <div class="asset-layout">
          <form class="asset-form" (ngSubmit)="saveBenchmark()">
            <h3 class="ssc-section-title">Benchmark Dataset</h3>
            <textarea [(ngModel)]="benchmarkForm.source_text" name="benchmark_source_text" placeholder="Source text"></textarea>
            <textarea [(ngModel)]="benchmarkForm.reference_translation" name="benchmark_reference" placeholder="Reference translation"></textarea>
            <input [(ngModel)]="benchmarkForm.dataset_name" name="benchmark_dataset" placeholder="Dataset name">
            <input [(ngModel)]="benchmarkForm.source_language" name="benchmark_source_language" placeholder="Source language">
            <input [(ngModel)]="benchmarkForm.target_language" name="benchmark_target_language" placeholder="Target language">
            <input [(ngModel)]="benchmarkForm.subject" name="benchmark_subject" placeholder="Subject">
            <input [(ngModel)]="benchmarkForm.difficulty" name="benchmark_difficulty" placeholder="Difficulty">
            <button class="ssc-btn primary" type="submit" [disabled]="saving">Add Benchmark</button>
          </form>
          <div class="asset-table-wrap">
            <table class="ssc-table">
              <thead><tr><th>Dataset</th><th>Source</th><th>Reference</th><th>Pair</th><th>Subject</th><th>Status</th></tr></thead>
              <tbody>
                @for (row of benchmarkRows; track row['id']) {
                  <tr>
                    <td>{{ text(row['dataset_name']) }}</td>
                    <td>{{ text(row['source_text']) }}</td>
                    <td>{{ text(row['reference_translation']) }}</td>
                    <td>{{ text(row['source_language']) }} -> {{ text(row['target_language']) }}</td>
                    <td>{{ text(row['subject']) }}</td>
                    <td>{{ text(row['status']) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </section>
  </section>
</app-ssc-shell>
